import React, { useState, useEffect, useRef } from 'react';
import { pipe } from 'fp-ts/lib/pipeable';
import { fold, Option } from 'fp-ts/lib/Option';

import { oneYearTerm, threeYearTerm, sixYearTerm, TermLength } from '../../../model/CalculatorInputs';
import '../InputSteps.scss';




interface Props {
    id: string;
    labelId: string;
    descriptionId: string;
    validationMessageId: string;

    term: Option<TermLength>;
    selectTerm: (term: TermLength) => void;
    deselectTerm: () => void;
    invalid: boolean;
    getRef: (ref: React.RefObject<HTMLSelectElement>) => void;

}

class TermLengthMenuItem {
    term: TermLength;
    label: string;

    constructor(term: TermLength) {
        this.term = term;
        this.label = this.term.years === 1 ? '1 year' : `${this.term.years} years`;
    }
}


export const SelectTermLength = (props: Props) => {

    const menuItems = [
        new TermLengthMenuItem(oneYearTerm),
        new TermLengthMenuItem(threeYearTerm),
        new TermLengthMenuItem(sixYearTerm)
    ];
    const termLengthsByYearString = new Map<string, TermLength>();
    for (const item of menuItems) {
        termLengthsByYearString.set(item.term.years.toString(), item.term);
    }

    const initialTermCode = pipe(props.term,
        fold(() => 'none',
            (invIdx) => invIdx.years.toString()));

    const [termCode, setTermCode] = useState<string>(initialTermCode);

    const termSelectRef = useRef<HTMLSelectElement>(null);
    props.getRef(termSelectRef);

    useEffect(() => {
        setTermCode(initialTermCode);
    }, [initialTermCode]);







    const classList = props.invalid ? ["select-term-length", "validation-error"] : ["select-term-length"];
    
    

    const termLengthId = 'rila-calculator-term-length-selector';

    const describedBy = props.invalid ? (props.validationMessageId) : undefined;


    function handleSelectionChange(event: React.ChangeEvent<HTMLSelectElement>) {
        const selectedYear = event.target.value;
        setTermCode(selectedYear);
        if (selectedYear === "none") {
            props.deselectTerm();
        } else if (termLengthsByYearString.has(selectedYear)) {
            const term = termLengthsByYearString.get(selectedYear)
            if (term) {
                props.selectTerm(term);
            }
        }
    }

    return (

            <fieldset>
                <legend className="sr-only">Term Length</legend>
                
                <div className={classList.join(' ')} aria-describedby={describedBy} >
                    <select id={termLengthId}
                        aria-describedby={describedBy}
                        aria-invalid={props.invalid}
                        data-testid={termLengthId}
                        className="form-control"
                        value={termCode}
                        ref={termSelectRef}
                        onChange={handleSelectionChange}>
                        {termCode === "none" ?
                        <option value="none">Select term length</option> : null}
                        {menuItems.map((item) =>
                            <option value={item.term.years.toString()} key={item.term.years}>{item.label}</option>
                        )}
                    </select>
                </div>
            </fieldset>
        
    )
}

